import { render } from "./ManualSyncTab.vue?vue&type=template&id=e6a3dcca&scoped=true"
import script from "./ManualSyncTab.vue?vue&type=script&lang=js"
export * from "./ManualSyncTab.vue?vue&type=script&lang=js"

import "./ManualSyncTab.vue?vue&type=style&index=0&id=e6a3dcca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a3dcca"]])

export default __exports__